import {
  BlockModel,
  BlockSchemaExtension,
  defineBlockSchema,
} from '@blocksuite/store';

export type ColumnsProps = {
  /**
   * Relative widths of the columns, in the order of `children`.
   * Reserved for a later resize handle — an empty array means "even".
   */
  widths?: number[];
  comments?: Record<string, boolean>;
};

export class ColumnsBlockModel extends BlockModel<ColumnsProps> {}

export const ColumnsBlockSchema = defineBlockSchema({
  flavour: 'affine:columns',
  props: (): ColumnsProps => ({
    widths: undefined,
    comments: undefined,
  }),
  metadata: {
    version: 1,
    role: 'hub',
    parent: ['affine:note', 'affine:edgeless-text'],
    children: ['affine:column'],
  },
  toModel: () => new ColumnsBlockModel(),
});

export const ColumnsBlockSchemaExtension =
  BlockSchemaExtension(ColumnsBlockSchema);

export type ColumnProps = {
  comments?: Record<string, boolean>;
};

export class ColumnBlockModel extends BlockModel<ColumnProps> {}

/**
 * A single column of `affine:columns`.
 *
 * Children mirror what a note accepts, minus `affine:columns` itself —
 * nested column layouts are out of scope for the MVP.
 */
export const ColumnBlockSchema = defineBlockSchema({
  flavour: 'affine:column',
  props: (): ColumnProps => ({
    comments: undefined,
  }),
  metadata: {
    version: 1,
    role: 'hub',
    parent: ['affine:columns'],
    children: [
      '@content',
      'affine:database',
      'affine:data-view',
      'affine:callout',
    ],
  },
  toModel: () => new ColumnBlockModel(),
});

export const ColumnBlockSchemaExtension =
  BlockSchemaExtension(ColumnBlockSchema);
